import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import immer from 'immer';
import { getKey } from '../utils/uid';
import normalizeWheel from '../utils/dom/normalizeWheel';
import ScrollBar from '../Scroll/Bar';
import { menuClass } from './styles';
import List from './List';
import { Provider } from './context';
import { isArray } from '../utils/is';
import { isRTL } from '../config';
import { Component } from '../component';
export var DefaultProps = {
  data: [],
  level: 0,
  keygen: 'id',
  mode: 'inline',
  inlineIndent: 24,
  renderItem: 'title',
  defaultOpenKeys: [],
  onClick: function onClick() {
    return true;
  },
  toggleDuration: 200,
  frontCaretType: 'solid',
  style: {},
  disabled: function (_disabled) {
    function disabled(_x) {
      return _disabled.apply(this, arguments);
    }

    disabled.toString = function () {
      return _disabled.toString();
    };

    return disabled;
  }(function (d) {
    return d.disabled;
  })
};
var modeDirection = {
  'vertical-auto': 'y',
  vertical: 'y',
  horizontal: 'x'
};

var getOption = function getOption(mode) {
  return mode.indexOf('vertical') === 0 ? {
    key: 'height',
    pos: 'Top',
    direction: 'Y'
  } : {
    key: 'width',
    pos: 'Left',
    direction: 'X'
  };
};

function keyToMap() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var keyMap = new Map();
  keys.forEach(function (v) {
    keyMap.set(v, value);
  });
  return keyMap;
} // function isSubMenu(el) {
//   if (el.matches(`.${menuClass('sub')}`)) return true
//   if (!el.parentElement) return false
//   return isSubMenu(el.parentElement)
// }


var Root =
/*#__PURE__*/
function (_Component) {
  _inherits(Root, _Component);

  var _super = _createSuper2(Root);

  function Root(props) {
    var _this;

    _classCallCheck(this, Root);

    _this = _super.call(this, props);
    _this.handleScrollLeft = void 0;
    _this.handleScrollTop = void 0;
    _this.items = void 0;
    _this.itemsOpen = void 0;
    _this.itemsInPath = void 0;
    _this.providerValue = void 0;
    _this.container = void 0;
    _this.hasToggled = void 0;
    _this.wrapper = void 0;
    _this.rootElement = void 0;
    _this.state = {
      activeKey: null,
      scrollTop: 0,
      scrollLeft: 0,
      openKeys: keyToMap(props.defaultOpenKeys)
    };
    _this.checkOpen = _this.checkOpen.bind(_assertThisInitialized(_this));
    _this.checkActive = _this.checkActive.bind(_assertThisInitialized(_this));
    _this.checkInPath = _this.checkInPath.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleScrollLeft = _this.handleScrollX.bind(_assertThisInitialized(_this), 'Left');
    _this.handleScrollTop = _this.handleScrollX.bind(_assertThisInitialized(_this), 'Top');
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.handleWheel = _this.handleWheel.bind(_assertThisInitialized(_this));
    _this.renderItem = _this.renderItem.bind(_assertThisInitialized(_this));
    _this.bindRootElement = _this.bindRootElement.bind(_assertThisInitialized(_this));
    _this.toggleOpenKeys = _this.toggleOpenKeys.bind(_assertThisInitialized(_this));
    _this.providerValue = {
      bindItem: _this.bindItem.bind(_assertThisInitialized(_this)),
      unbindItem: _this.unbindItem.bind(_assertThisInitialized(_this))
    };
    _this.items = {};
    _this.itemsOpen = {};
    _this.itemsInPath = {};
    return _this;
  }

  _createClass(Root, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Root.prototype), "componentDidMount", this).call(this);

      this.updateState();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateState();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.container.removeEventListener('wheel', this.handleWheel);

      _get(_getPrototypeOf(Root.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "getOpenKeys",
    value: function getOpenKeys() {
      var _this$props = this.props,
          openKeys = _this$props.openKeys,
          defaultOpenKeys = _this$props.defaultOpenKeys;
      if (openKeys) return openKeys;
      return this.hasToggled ? Array.from(this.state.openKeys.keys()) : defaultOpenKeys;
    }
  }, {
    key: "bindRootElement",
    value: function bindRootElement(el) {
      this.container = el;
      if (!el) return;
      this.wrapper = el.querySelector(".".concat(menuClass('wrapper')));
      this.rootElement = el.querySelector(".".concat(menuClass('root')));
    }
  }, {
    key: "bindItem",
    value: function bindItem(id, updateActive, updateOpen, updateInPath) {
      this.items[id] = updateActive;
      this.itemsOpen[id] = updateOpen;
      this.itemsInPath[id] = updateInPath;
      return [this.checkActive, this.checkOpen, this.checkInPath];
    }
  }, {
    key: "unbindItem",
    value: function unbindItem(id) {
      delete this.items[id];
      delete this.itemsOpen[id];
      delete this.itemsInPath[id];
    }
  }, {
    key: "checkActive",
    value: function checkActive(id, data) {
      var active = this.props.active;
      var act = typeof active === 'function' ? active(data) : id === this.state.activeKey; // @ts-ignore 历史原因，待优化

      if (act) this.state.activeKey = id;

      if (!act && this.state.activeKey === id) {
        // @ts-ignore 历史原因，待优化
        this.state.activeKey = '';
      }

      return act;
    }
  }, {
    key: "checkOpen",
    value: function checkOpen(id) {
      var openKeys = this.getOpenKeys();

      if (isArray(openKeys)) {
        return openKeys.indexOf(id) > -1;
      }

      return false;
    }
  }, {
    key: "checkInPath",
    value: function checkInPath(id) {
      var activeKey = this.state.activeKey;
      if (!activeKey || !id) return false;
      return activeKey.indexOf(id) >= 0;
    }
  }, {
    key: "updateState",
    value: function updateState() {
      var mode = this.props.mode;
      this.updateActive();
      this.updateOpen();
      this.updateInPath();
      if (!this.container) return;
      var bindMethod = mode !== 'inline' ? this.container.addEventListener : this.container.removeEventListener;
      bindMethod.call(this.container, 'wheel', this.handleWheel, {
        passive: false
      });
    }
  }, {
    key: "updateActive",
    value: function updateActive() {
      var _this2 = this;

      Object.keys(this.items).forEach(function (id) {
        var update = _this2.items[id];
        update(_this2.checkActive, _this2.state.activeKey);
      });
    }
  }, {
    key: "updateOpen",
    value: function updateOpen() {
      var _this3 = this;

      var _this$props2 = this.props,
          data = _this$props2.data,
          keygen = _this$props2.keygen;
      Object.keys(this.itemsOpen).forEach(function (id) {
        var update = _this3.itemsOpen[id];
        update(_this3.checkOpen);
      });
      var hasOpen = this.getOpenKeys().filter(function (k) {
        return data.find(function (d, i) {
          return getKey(d, keygen, i) === k;
        });
      }).length > 0;

      if (hasOpen !== this.state.hasOpen) {
        this.setState({
          hasOpen: hasOpen
        });
      }
    }
  }, {
    key: "updateInPath",
    value: function updateInPath() {
      var _this4 = this;

      Object.keys(this.itemsInPath).forEach(function (id) {
        var update = _this4.itemsInPath[id];
        update(_this4.checkInPath);
      });
    }
  }, {
    key: "toggleOpenKeys",
    value: function toggleOpenKeys(id, open) {
      var newOpenKeys = immer(keyToMap(this.getOpenKeys()), function (draft) {
        if (open) {
          draft.set(id, true);
        } else draft["delete"](id);
      });
      this.hasToggled = true;
      var keys = Array.from(newOpenKeys.keys());
      var _this$props3 = this.props,
          _this$props3$onOpenCh = _this$props3.onOpenChange,
          onOpenChange = _this$props3$onOpenCh === void 0 ? function () {} : _this$props3$onOpenCh,
          openKeys = _this$props3.openKeys;

      if (openKeys) {
        onOpenChange(keys);
        return;
      }

      this.setState({
        openKeys: newOpenKeys,
        hasOpen: keys.length > 0
      });
      onOpenChange(keys);
    }
  }, {
    key: "handleScrollX",
    value: function handleScrollX(pos, param) {
      var sizeKey = pos === 'Top' ? 'height' : 'width';
      var size = this.container.getBoundingClientRect()[sizeKey];
      var scroll = this.rootElement.getBoundingClientRect()[sizeKey];
      this.wrapper["scroll".concat(pos)] = param * (scroll - size);
      this.setState(_defineProperty({}, "scroll".concat(pos), param));
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(top) {
      var _this$container$getBo = this.container.getBoundingClientRect(),
          height = _this$container$getBo.height;

      var scrollHeight = this.rootElement.getBoundingClientRect().height;
      this.wrapper.scrollTop = top * (scrollHeight - height);
      this.setState({
        scrollTop: top
      });
    }
  }, {
    key: "handleWheel",
    value: function handleWheel(e) {
      // if (isSubMenu(e.target)) return
      var mode = this.props.mode;

      var _getOption = getOption(mode),
          key = _getOption.key,
          pos = _getOption.pos,
          direction = _getOption.direction;

      var wheel = normalizeWheel(e);
      var size = this.container.getBoundingClientRect()[key]; // const size = this.rootElement.getBoundingClientRect()[key] - this.container.getBoundingClientRect()[key]

      this.wrapper["scroll".concat(pos)] += wheel["pixel".concat(direction)];
      var precent = this.wrapper["scroll".concat(pos)] / size;
      this.setState(_defineProperty({}, "scroll".concat(pos), precent > 1 ? 1 : precent)); // this.setState({ [`scroll${pos}`]: size === 0 ? 0 : this.wrapper[`scroll${pos}`] / size })

      e.preventDefault();
    }
  }, {
    key: "handleClick",
    value: function handleClick(id, data) {
      var onClick = this.props.onClick;
      this.setState({
        activeKey: id
      });
      if (onClick) onClick(data);
    }
  }, {
    key: "renderItem",
    value: function renderItem(data, index) {
      var renderItem = this.props.renderItem;
      if (typeof renderItem === 'string') return data[renderItem];
      if (typeof renderItem === 'function') return renderItem(data, index);
      return null;
    }
  }, {
    key: "renderScrollBar",
    value: function renderScrollBar() {
      if (!this.rootElement || !this.container) return null;
      var mode = this.props.mode;
      var direction = modeDirection[mode];
      if (!direction) return null;

      if (direction === 'x') {
        var _this$container$getBo2 = this.container.getBoundingClientRect(),
            width = _this$container$getBo2.width;

        var scrollWidth = this.rootElement.getBoundingClientRect().width;
        if (scrollWidth <= width) return null;
        return (
          /*#__PURE__*/
          React.createElement(ScrollBar, {
            className: menuClass('bar'),
            length: width,
            scrollLength: scrollWidth,
            offset: this.state.scrollLeft,
            onScroll: this.handleScrollLeft,
            direction: "x"
          })
        );
      }

      var length = this.container.getBoundingClientRect().height;
      var scrollHeight = this.rootElement.getBoundingClientRect().height;
      if (scrollHeight < length) return null;
      return (
        /*#__PURE__*/
        React.createElement(ScrollBar, {
          className: menuClass('bar'),
          forceHeight: length,
          length: length,
          scrollLength: scrollHeight,
          offset: this.state.scrollTop,
          onScroll: this.handleScrollTop
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          _this$props4$data = _this$props4.data,
          data = _this$props4$data === void 0 ? DefaultProps.data : _this$props4$data,
          mode = _this$props4.mode,
          style = _this$props4.style,
          theme = _this$props4.theme,
          height = _this$props4.height,
          keygen = _this$props4.keygen,
          linkKey = _this$props4.linkKey,
          disabled = _this$props4.disabled,
          caretColor = _this$props4.caretColor,
          frontCaret = _this$props4.frontCaret,
          inlineIndent = _this$props4.inlineIndent,
          looseChildren = _this$props4.looseChildren,
          frontCaretType = _this$props4.frontCaretType,
          toggleDuration = _this$props4.toggleDuration,
          parentSelectable = _this$props4.parentSelectable;
      var isVertical = mode.indexOf('vertical') === 0;
      var showScroll = (style && style.height || height) && isVertical || mode === 'horizontal';
      var rtl = isRTL();
      var className = classnames(menuClass('_', isVertical ? 'vertical' : mode, theme === 'dark' && 'dark', showScroll && 'scroll', this.state.hasOpen && 'has-open', rtl && 'rtl'), this.props.className);
      var rootStyle = {};
      if (style && style.width && mode !== 'horizontal') rootStyle.width = style.width;
      var bottomLine = 0;
      var topLine = 0;

      if (this.container) {
        var rect = this.container.getBoundingClientRect();
        bottomLine = rect.bottom;
        topLine = rect.top;
      }

      var outStyle = _objectSpread2({}, style);

      if (height !== undefined) outStyle.height = height;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          ref: this.bindRootElement,
          style: outStyle
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: menuClass('wrapper')
        },
        /*#__PURE__*/
        React.createElement(Provider, {
          value: this.providerValue
        },
        /*#__PURE__*/
        React.createElement(List, {
          path: "",
          level: 0,
          mode: mode,
          data: data,
          keygen: keygen,
          style: rootStyle,
          topLine: topLine,
          linkKey: linkKey,
          disabled: disabled,
          frontCaret: frontCaret,
          bottomLine: bottomLine,
          caretColor: caretColor,
          onClick: this.handleClick,
          inlineIndent: inlineIndent,
          renderItem: this.renderItem,
          className: menuClass('root'),
          looseChildren: looseChildren,
          frontCaretType: frontCaretType,
          toggleDuration: toggleDuration,
          parentSelectable: parentSelectable,
          toggleOpenKeys: this.toggleOpenKeys
        }))), showScroll && this.renderScrollBar())
      );
    }
  }]);

  return Root;
}(Component);

Root.defaultProps = DefaultProps;
Root.displayName = void 0;
export default Root;